import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'characterCount',
    standalone: false
})
export class CharacterCountPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    if(!value){return 0}
    const len = value?.toString()?.length
    if(len){
      return len
    }
    return 0
  }

}
